function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivatedNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 27.309 28.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Notification Bell Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Bell",
    d: "M1676.867 96.184v-5.455a6.635 6.635 0 0 0-13.268 0v5.456a4.3 4.3 0 0 1-.592 2.182h14.451a4.3 4.3 0 0 1-.591-2.183zm4.423 4.364h-22.114a1.091 1.091 0 1 1 0-2.182 2.2 2.2 0 0 0 2.211-2.182v-5.455a8.846 8.846 0 0 1 17.691 0v5.456a2.2 2.2 0 0 0 2.211 2.182 1.091 1.091 0 1 1 .001 2.182zm-8.187 3.821a3.339 3.339 0 0 1-5.739 0 1.091 1.091 0 0 1 .956-1.638h3.826a1.091 1.091 0 0 1 .954 1.638z",
    transform: "translate(-1658.07 -77.846)",
    style: {
      fill: "#0F1177"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 2",
    transform: "translate(16.309 3)",
    style: {
      fill: "#0F1177",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 5.5,
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivatedNotification);
export default __webpack_public_path__ + "static/media/activated-notification.dc6b79c48ee22be7b3edc0174c519208.svg";
export { ForwardRef as ReactComponent };